/* import __COLOCATED_TEMPLATE__ from './commands-picker.hbs'; */
/* RESPONSIBLE TEAM: team-actions */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import type CommandsResolver from 'embercom/lib/workflows/commands-resolver';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

interface Args {
  filterPlaceholder?: string;
  operation: string;
  commandsResolver: CommandsResolver;
  onSelectAttribute: (identifier: string) => void;
}

export default class CommandsPicker extends Component<Args> {
  @service intl: $TSFixMe;
  @tracked searchQuery = '';

  get filterPlaceholder(): string {
    return (
      this.args.filterPlaceholder ||
      this.intl.t(
        'operator.workflows.visual-builder.fin-custom-settings.inline-attribute.search-commands-placeholder',
      )
    );
  }

  get items() {
    switch (this.args.operation) {
      case 'tags':
        return [this.args.commandsResolver.tags];
      case 'actions':
        return [this.args.commandsResolver.actions];
      case 'escalate_conversation':
        return [
          this.args.commandsResolver.defaultTeam,
          this.args.commandsResolver.teams,
          this.args.commandsResolver.teammates,
        ];
      default:
        return [];
    }
  }

  get filteredItems() {
    let query = this.searchQuery.toLowerCase();
    return this.items
      .map((group: any) => {
        return {
          ...group,
          attributes: group.attributes.filter((attr: any) =>
            attr.name.toLowerCase().includes(query),
          ),
        };
      })
      .filter((group: any) => group.attributes.length > 0);
  }

  @action
  updateSearchQuery(query: string): void {
    this.searchQuery = query;
  }

  @action
  onSelectAttribute(selectedAttribute: any): void {
    this.args.onSelectAttribute(selectedAttribute.identifier);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::FinCustom::AiPromptDataPopover::CommandsPicker': typeof CommandsPicker;
  }
}
